import { gql } from '@apollo/client';

/**
 * Minimal query that fetches only the poster/thumbnail image URLs for a set of media IDs.
 * Use this instead of the full `getMediaByIDsQuery` when only poster images are needed,
 * to avoid over-fetching unneeded fields (seasons, details, cast, badges, etc.).
 */
export const getPostersByIdsQuery = gql`
  query postersByIds($sessionContext: SessionContext!, $ids: [String!]!) {
    medias(sessionContext: $sessionContext, ids: $ids) {
      id
      title
      metadataImages {
        poster {
          url
        }
      }
    }
  }
`;
